import { useFieldArray, useFormContext } from "react-hook-form";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { Grid, List, ListItem, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { Link } from "react-router";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Visibility } from "@mui/icons-material";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import React from "react";
import { FormattedNumber } from "react-intl";

export default function ParentProducts() {
  const { control, vestiging } = useFormContext();
  const { fields, replace } = useFieldArray({
    control,
    name: "parent_products",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant={"h5"}>
              <TranslationWrapper tDefault={"Parent products"} tKey={"option_groups.parent_products.products_title"} />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <AddParentProduct fields={fields} replace={replace} />
          </Grid>
          <Grid item xs={12}>
            <List>
              <ListItem>
                <Grid container>
                  <Grid item xs={6}>
                    <TranslationWrapper tKey={"Product name"} />
                  </Grid>
                  <Grid item xs={6} />
                </Grid>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem key={field.value}>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography style={{ margin: "0 16px" }}>
                          {field.naam} -{" "}
                          <FormattedNumber
                            currency={vestiging?.valuta ?? "EUR"}
                            style={"currency"}
                            value={field.prijs}
                          />
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Link to={`/manager/producten/${field.id}/edit`}>
                          <Tooltip
                            classes={{}}
                            placement={"bottom"}
                            title={
                              <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                            }
                          >
                            <Button color={"success"} simple>
                              <Visibility />
                            </Button>
                          </Tooltip>
                        </Link>
                      </Grid>
                    </Grid>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
}

function AddParentProduct({ replace, fields }) {
  const { menukaartVestigingId } = useFormContext();

  return (
    <AsynchronousAutocomplete
      async={{
        url: `core/producten/search?fields=id as value,id,naam as label,prijs,vestiging_id,naam,sortkey&sort_field=naam&sort_dir=asc&vestiging_id=${menukaartVestigingId}`,
        searchField: "naam",
        perPage: 20,
      }}
      key={menukaartVestigingId}
      multiple={true}
      onChange={(e, option) => {
        replace(option);
      }}
      placeholder={getTranslation("Find product")}
      value={(fields ?? []).map((field) => {
        field.value = field.id = field.id ?? field.value;
        field.label = field.naam = field.naam ?? field.label;

        return field;
      })}
    />
  );
}
